import React, { useState } from "react";
import {
  Dialog,
  useTheme,
  Stack,
  DialogContent,
  TextField,
  Grid,
  Typography,
  } from "@mui/material";
import CustomButton from "../../components/CustomButton";
import { tokens } from "../../theme";
import { useEffect } from "react";

function CancelAdjustment({
  open,
  onClose,
  cancelAdjustmentButtonClicked,
  data,
}) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    if (data) {
    


      const value = {
        dealer: data.dealerName,
        type: data.type,
        description: data.description,
        amount:data.amount,
        date:data.date,
        id:data.id
      };
      setFormData(value);
    }

   
    setDialogOpen(open);
  }, [open, data]);

  const [formData, setFormData] = useState({
    dealer: "",
    type: "",
    description: "",
    amount: "",
    //reason:"",

  });
  const [errors, setErrors] = useState({});

  const [dialogOpen, setDialogOpen] = useState(open);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  
  const handleRemove = (e) => {
    e.preventDefault();
   
      // Close the dialog
      onClose();

     // onDialogButtonClick(selectedItem, formData);
     //dismissDialog();
      // You can perform additional actions like sending data to a server here
  
   
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validation logic
    const newErrors = {};

    if (!formData.dealer.trim()) {
      newErrors.dealer = "Dealer is required";
    }

    if (!formData.type) {
      newErrors.type = "Type is required";
    }

    if (!formData.description) {
      newErrors.description = "Description is required";
    }

    if (!formData.amount) {
      newErrors.amount = "Amount is required";
    }

    // if (!formData.reason) {
    //   newErrors.reason = "Reason is required";
    // }

    if (Object.keys(newErrors).length === 0) {
      

      // Close the dialog
       onClose();

     // onDialogCancelAdjustmentButtonClick(selectedItem, formData,1);
     cancelAdjustmentButtonClicked(formData,1);

      // You can perform additional actions like sending data to a server here
    } else {
      // Form is not valid, update the errors state
      setErrors(newErrors);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}   maxWidth="lg" >
      <DialogContent>
        <Grid container direction={"column"}>
          <Grid container  >
            <Grid container justifyContent="center" alignItems="center" item>
              <Typography fontWeight={"600"} variant="h3" p={1}>
                Cancel Scheduled Adjustment
              </Typography>
            </Grid>
            <Grid container justifyContent="center" alignItems="center" item>
              <Typography fontSize={"14px"} fontWeight={"400"} pb={4}  >
                Are you sue you want to cancel the scheduled adjustment (unposted)
              </Typography>
            </Grid>
          </Grid>

          <form>
            <Grid container direction={"column"}>
           
              <Grid container xs={12} alignItems={"center"} spacing={3}  pb={.5}>
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                    Dealer
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Dealer"
                    type="text"
                    name="dealer"
                    disabled
                    fullWidth
                    value={formData.dealer}
                    onChange={handleInputChange}
                    error={Boolean(errors.dealer)}
                    helperText={errors.dealer}
                  />
                </Grid>
              </Grid>

              <Grid container xs={12} alignItems={"center"} spacing={3}  pb={.5}>
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                    Type
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Type"
                    type="text"
                    name="type"
                    disabled
                    fullWidth
                    value={formData.type}
                    onChange={handleInputChange}
                    error={Boolean(errors.type)}
                    helperText={errors.type}
                  />
                </Grid>
              </Grid>

              <Grid container xs={12} alignItems={"center"} spacing={3}  pb={.5}>
                <Grid item xs={4}>
                  <Typography
                   
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                   Description
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Description"
                    type="text"
                    disabled
                    name="description"
                    fullWidth
                    value={formData.description}
                    onChange={handleInputChange}
                    error={Boolean(errors.description)}
                    helperText={errors.description}
                  />
                </Grid>
              </Grid>


              <Grid container xs={12} alignItems={"center"} spacing={3}  pb={.5}>
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                  Amount
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Amount"
                    type="text"
                    name="amount"
                    disabled
                    fullWidth
                    value={formData.amount}
                    onChange={handleInputChange}
                    error={Boolean(errors.amount)}
                    helperText={errors.amount}
                  />
                </Grid>
              </Grid>


            


              {/* <Grid container xs={12} alignItems={"center"} spacing={3}  pb={.5}>
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                   Reason
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Reason"
                    type="text"
                    name="reason"
                    fullWidth
                    value={formData.reason}
                    onChange={handleInputChange}
                    error={Boolean(errors.reason)}
                    helperText={errors.reason}
                  />
                </Grid>
              </Grid> */}


            

              <Stack
                direction="row"
                pt={2}
                spacing={2}
                justifyContent={"center"}
              >
                <CustomButton
                  btnBG={colors.primary[900]}
                  btnColor={colors.grey[100]}
                  btnTxt={"CLOSE"}
                  btnBorder={"1px solid" + colors.primary[800]}
                  onClick={handleRemove}
                ></CustomButton>

                <CustomButton
                  btnBG={colors.primary[100]}
                  btnColor={colors.grey[900]}
                  btnTxt={"CANCEL ADJUSTMENT"}
                  btnBorder={"1px solid" + colors.primary[100]}
                  onClick={handleSubmit}
                ></CustomButton>
              </Stack> 
            </Grid>

            {/* Add more fields as needed */}
          </form>
        </Grid>
      </DialogContent>
      
    </Dialog>
  );
}

export default CancelAdjustment;
